import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Background from "../login/_background";
import { adminBookingLogin, adminAutocomplete } from "../../services/adminAuth";
import { bookingActions } from "../../redux/slices/bookingSlice";
import { loaderActions } from "../../redux/slices/loadingSlice";
import { useAppDispatch } from "../../redux/store";

const AdminBookingPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [bookingNumber, setBookingNumber] = useState("");
  const [options, setOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const isAdmin = sessionStorage.getItem("adminAuthenticated");
    if (isAdmin !== "true") {
      navigate("/admin");
    }
  }, [navigate]);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!bookingNumber) return;
    
    dispatch(loaderActions.showLoader());
    setError("");

    const response = await adminBookingLogin(bookingNumber);

    if (response) {
      sessionStorage.setItem("lmxBooking", JSON.stringify(response));
      dispatch(bookingActions.setBookingData(response));
      dispatch(loaderActions.hideLoader());
      
      if (response.isCanceled || response.isExpired) {
        navigate("/info");
      } else {
        navigate("/booking-details");
      }
    } else {
      dispatch(loaderActions.hideLoader());
      setError("Booking not found or login failed");
    }
  };

  return (
    <div className="w-screen h-screen relative">
      <Background />

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-5/6 md:w-3/6 lg:w-2/6 space-y-3">
        <form
          onSubmit={onSubmit}
          className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-lg space-y-4"
        >
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-4">
            Booking Search (Admin)
          </h2>

          {error && (
            <div className="text-red-500 text-center text-sm">{error}</div>
          )}

          <Autocomplete
            freeSolo
            options={options}
            loading={loading}
            onInputChange={async (event, newInputValue) => {
              setBookingNumber(newInputValue);
              if (newInputValue.length >= 3) {
                setLoading(true);
                const results = await adminAutocomplete(newInputValue);
                setOptions(results || []);
                setLoading(false);
              } else {
                setOptions([]);
              }
            }}
            onChange={(event, value) => {
                if (typeof value === 'string') {
                    setBookingNumber(value);
                }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Booking Number"
                variant="outlined"
                required
                fullWidth
                helperText="Type at least 3 digits for suggestions"
              />
            )}
          />

          <Button
            type="submit"
            variant="contained"
            color="secondary"
            fullWidth
            className="bg-secondary hover:bg-secondary-hover py-2 text-white"
          >
            Find Booking
          </Button>
          
          <Button
            onClick={() => {
              sessionStorage.removeItem("adminAuthenticated");
              navigate("/admin");
            }}
            fullWidth
            className="text-gray-500 text-sm mt-2"
          >
            Logout Admin
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminBookingPage;
